import { getAxiosClient } from "../../axios-client";
import { GetOrdersDetailsGetByIdBody, GetOrdersDetailsResponse } from "./types";

const axiosClient = getAxiosClient();
export const getOrdersDetailsGetById = async (body: GetOrdersDetailsGetByIdBody) => {
    return await axiosClient.ax.post<GetOrdersDetailsResponse>(
        "/Orders/OrdersDetailsGetById",
        body
    );
};